'use client';
import { XYCHART_TICK_LABEL_COLOR } from './xychart-constants';
import type { XYChartLayout } from './xychart-types';
export interface XYChartTickLabelsProps {
    layout: XYChartLayout;
}
function getTickLabelDebugIdentity(tick: XYChartLayout['ticks'][number]): string {
    return `${tick.label}-value-${tick.value}`;
}
export function XYChartTickLabels({ layout }: XYChartTickLabelsProps) {
    if (layout.horizontal) {
        return (
        <>
        {layout.ticks.map((tick) => (<text key={`tick-x-${tick.value}`} x={tick.position} y={layout.plotHeight + 18} textAnchor="middle" fontSize={11} fontWeight={500} fill={XYCHART_TICK_LABEL_COLOR}>
            {tick.label}
          </text>))}
        </>
      );
    }
    return (
      <>
      {layout.ticks.map((tick) => (<text key={`tick-y-${tick.value}`} x={-10} y={tick.position + 4} textAnchor="end" fontSize={11} fontWeight={500} fill={XYCHART_TICK_LABEL_COLOR}>
          {tick.label}
        </text>))}
      </>
    );
}
